/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    GetWaitlistSubscriptionsParams,
    RequestStatusResponseResponse,
    WaitlistBulkReminderBodyBody,
    WaitlistBulkReminderSuccessResponseResponse,
    WaitlistConvertToBookingSuccessResponseResponse,
    WaitlistFilterOptionsSuccessResponseResponse,
    WaitlistSubscriptionsSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get waitlist subscriptions with fulfillability status
 */
export const getWaitlistSubscriptions = (
    params?: GetWaitlistSubscriptionsParams,
    signal?: AbortSignal,
) => {
    return customInstance<WaitlistSubscriptionsSuccessResponseResponse>({
        url: `/waitlist-subscriptions`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetWaitlistSubscriptionsQueryKey = (params?: GetWaitlistSubscriptionsParams) => {
    return [`/waitlist-subscriptions`, ...(params ? [params] : [])] as const;
};

export const getGetWaitlistSubscriptionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getWaitlistSubscriptions>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetWaitlistSubscriptionsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getWaitlistSubscriptions>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetWaitlistSubscriptionsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWaitlistSubscriptions>>> = ({
        signal,
    }) => getWaitlistSubscriptions(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getWaitlistSubscriptions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetWaitlistSubscriptionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getWaitlistSubscriptions>>
>;
export type GetWaitlistSubscriptionsQueryError = APIErrorResponseResponse;

/**
 * @summary Get waitlist subscriptions with fulfillability status
 */

export function useGetWaitlistSubscriptions<
    TData = Awaited<ReturnType<typeof getWaitlistSubscriptions>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetWaitlistSubscriptionsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getWaitlistSubscriptions>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetWaitlistSubscriptionsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get show and timeslot options for waitlist filters
 */
export const getWaitlistFilterOptions = (signal?: AbortSignal) => {
    return customInstance<WaitlistFilterOptionsSuccessResponseResponse>({
        url: `/waitlist-subscriptions/filters`,
        method: 'GET',
        signal,
    });
};

export const getGetWaitlistFilterOptionsQueryKey = () => {
    return [`/waitlist-subscriptions/filters`] as const;
};

export const getGetWaitlistFilterOptionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getWaitlistFilterOptions>>,
    TError = APIErrorResponseResponse,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWaitlistFilterOptions>>, TError, TData>;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetWaitlistFilterOptionsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWaitlistFilterOptions>>> = ({
        signal,
    }) => getWaitlistFilterOptions(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getWaitlistFilterOptions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetWaitlistFilterOptionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getWaitlistFilterOptions>>
>;
export type GetWaitlistFilterOptionsQueryError = APIErrorResponseResponse;

/**
 * @summary Get show and timeslot options for waitlist filters
 */

export function useGetWaitlistFilterOptions<
    TData = Awaited<ReturnType<typeof getWaitlistFilterOptions>>,
    TError = APIErrorResponseResponse,
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getWaitlistFilterOptions>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetWaitlistFilterOptionsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Send reminders for selected waitlist subscriptions
 */
export const sendBulkWaitlistReminder = (
    waitlistBulkReminderBodyBody: WaitlistBulkReminderBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<WaitlistBulkReminderSuccessResponseResponse>({
        url: `/waitlist-subscriptions/send-bulk-reminder`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: waitlistBulkReminderBodyBody,
        signal,
    });
};

export const getSendBulkWaitlistReminderMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendBulkWaitlistReminder>>,
        TError,
        { data: WaitlistBulkReminderBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sendBulkWaitlistReminder>>,
    TError,
    { data: WaitlistBulkReminderBodyBody },
    TContext
> => {
    const mutationKey = ['sendBulkWaitlistReminder'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sendBulkWaitlistReminder>>,
        { data: WaitlistBulkReminderBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return sendBulkWaitlistReminder(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SendBulkWaitlistReminderMutationResult = NonNullable<
    Awaited<ReturnType<typeof sendBulkWaitlistReminder>>
>;
export type SendBulkWaitlistReminderMutationBody = WaitlistBulkReminderBodyBody;
export type SendBulkWaitlistReminderMutationError = APIErrorResponseResponse;

/**
 * @summary Send reminders for selected waitlist subscriptions
 */
export const useSendBulkWaitlistReminder = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendBulkWaitlistReminder>>,
        TError,
        { data: WaitlistBulkReminderBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sendBulkWaitlistReminder>>,
    TError,
    { data: WaitlistBulkReminderBodyBody },
    TContext
> => {
    const mutationOptions = getSendBulkWaitlistReminderMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete waitlist subscription
 */
export const deleteWaitlistSubscription = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/waitlist-subscriptions/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteWaitlistSubscriptionMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteWaitlistSubscription>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteWaitlistSubscription>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteWaitlistSubscription'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteWaitlistSubscription>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return deleteWaitlistSubscription(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteWaitlistSubscriptionMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteWaitlistSubscription>>
>;

export type DeleteWaitlistSubscriptionMutationError = APIErrorResponseResponse;

/**
 * @summary Delete waitlist subscription
 */
export const useDeleteWaitlistSubscription = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteWaitlistSubscription>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteWaitlistSubscription>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteWaitlistSubscriptionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Convert a fulfillable waitlist entry into a pending booking with auto-assigned seats
 */
export const convertWaitlistToBooking = (id: number, signal?: AbortSignal) => {
    return customInstance<WaitlistConvertToBookingSuccessResponseResponse>({
        url: `/waitlist-subscriptions/${id}/convert-to-booking`,
        method: 'POST',
        signal,
    });
};

export const getConvertWaitlistToBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof convertWaitlistToBooking>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof convertWaitlistToBooking>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['convertWaitlistToBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof convertWaitlistToBooking>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return convertWaitlistToBooking(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type ConvertWaitlistToBookingMutationResult = NonNullable<
    Awaited<ReturnType<typeof convertWaitlistToBooking>>
>;

export type ConvertWaitlistToBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Convert a fulfillable waitlist entry into a pending booking with auto-assigned seats
 */
export const useConvertWaitlistToBooking = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof convertWaitlistToBooking>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof convertWaitlistToBooking>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getConvertWaitlistToBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
